module.exports = __webpack_public_path__ + "img/logoZain.a25a4b25.svg";